// client/languageSubject.ts
import { LocalStorageReactive } from "@adornis/base/rxjs-extension/index.js";
import { baseConfig } from "@adornis/config/baseConfig.js";
import { Language } from "../languages.js";
var languageGuard = (lang) => Object.values(Language).includes(lang);
var defaultLanguage = baseConfig.get("DEFAULT_LANGUAGE");
if (!languageGuard(defaultLanguage))
  throw new Error(`invalid DEFAULT_LANGUAGE "${defaultLanguage}", expected one of ${Object.values(Language)}`);
var globalLanguageSubject = new LocalStorageReactive("language", defaultLanguage);
export {
  globalLanguageSubject
};
